import React from 'react';
import { RegisterOptions } from 'react-hook-form/dist/index.ie11';
import { BaseAddressInput } from 'src/components/BaseAddressInput/BaseAddressInput';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';

export interface InvoiceContactAddressControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export function InvoiceContactAddressControl({
  name,
  id,
  rules,
}: InvoiceContactAddressControlProps): JSX.Element {
  return (
    <BaseAddressInput
      name={name}
      id={id}
      label={addAsterisk('Address', rules)}
      placeholder="e.g. 1065 Avenue of America"
      rules={rules}
    />
  );
}
